module.exports = __webpack_public_path__ + "static/media/fixedReplyIcon.61557f2c.svg";